export enum SUB_PRODUCT_LINE_IDS {
  REPORT = 1,
  DESIGN = 2,
  PERFORM = 3,
  PERFORM_LITE = 31,
  VIVIEN = 5,
  NONE = 24,
  LEARN = 33,
}

export const WYSIWYG_SUB_PRODUCT_LINE_IDS = [
  SUB_PRODUCT_LINE_IDS.REPORT,
  SUB_PRODUCT_LINE_IDS.DESIGN,
  SUB_PRODUCT_LINE_IDS.PERFORM,
  SUB_PRODUCT_LINE_IDS.PERFORM_LITE,
];
